module.exports = __webpack_public_path__ + "img/pinganyunecs.e75d4c8a.svg";